import Add from "./Add";
import { AppProvider } from "./statesProvider/materialContext";

const RFQIndex = () => {
  return (
    <AppProvider>
      <Add />
    </AppProvider>
  );
};

export default RFQIndex;
